<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :label-width="'115px'"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <template>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessStockSearch.header.warehouseCode')" prop="warehouseCode">
              <BjInput
                v-model="queryParams.warehouseCode"
                :maxlength="MAX_LENGTH.DEFAULT"
                :placeholder="$t('BusinessStockSearch.header.warehouseCode')"
                clearable
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessStockSearch.header.warehouseId')" prop="warehouseId">
              <BjSelectWarehouse v-model="queryParams.warehouseId" :placeholder="$t('BusinessStockSearch.header.warehouseId')" multiple />
            </el-form-item>
          </el-col>
        </template>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockSearch.header.skuCode')" prop="skuCode">
            <BjInput
              v-model="queryParams.skuCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('BusinessStockSearch.header.skuCode')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockSearch.header.categoryIdList')" prop="categoryIdList">
            <BjGoodsTypeTreeSelect v-model="queryParams.categoryIdList" :placeholder="$t('BusinessStockSearch.header.categoryIdList')" multiple />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockSearch.header.warehouseTypeCode')" prop="warehouseTypeCode">
            <BjSelectLov
              v-model="queryParams.warehouseTypeCode"
              :placeholder="$t('BusinessStockSearch.header.warehouseTypeCode')"
              multiple
              lov-code="STOCK.WAREHOUSE_TYPE"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockSearch.header.exceedZero')" prop="exceedZero">
            <BjSelectLov v-model="queryParams.exceedZero" :placeholder="$t('BusinessStockSearch.header.exceedZero')" constant-key="STATUS_YES_TRUE" />
          </el-form-item>
        </el-col>
      </template>
      <!-- <template v-slot:tableOperation>
        <el-col>
            <el-button type="primary"  @click="onAdd">添 加</el-button>

            <el-button type="primary"  @click="onDown">{{ $t('downloadTemplateText') }}</el-button>
          </el-col>
        </div>
      </template> -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'stockNum'">{{ (scope.row.stockNum - scope.row.lockNum).toFixed(0) }}</span>
              <span v-else-if="col.prop === 'typeCode'">{{
                $store.state.values.STOCK_WAREHOUSE_TYPE.bjGet(scope.row[col.prop])
              }}</span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            align="center"
          >
            <!-- <template slot-scope="props"> -->
            <!-- <el-button type="text"  @click="onUpdata(props.row)">更 新</el-button>
              <el-button type="text"  @click="onSync(props.row)">同 步</el-button> -->
            <!-- </template> -->
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 添加库存初始化弹窗 -->
    <!-- <DataForm ref="DataForm" @reFresh="reFresh" /> -->
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
// import DataForm from './components/DataForm.vue';
const getDefaultForm = () => {
  return {};
};

export default {
  name: 'BusinessStockSearch',
  // components: { DataForm },
  mixins: [pageMiXin],
  data() {
    return {
      queryApi: stockApi.getGoodsStockPage,
      colSpan: 4,
      // 查询参数
      queryParams: {
        categoryIdList: [],
        exceedZero: null,
        skuCode: null,
        spuCode: null,
        spuName: null,
        warehouseCode: null,
        warehouseId: [],
        warehouseTypeCode: [],
      },
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {},
      labelsVersion: 11,
      labelList: [
        // { label: 'goodsPage.spuCode', prop: 'spuCode', isCheck: true, disabled: false, width: '160px' },
        // { label: 'goodsPage.spuName', prop: 'spuName', isCheck: true, disabled: false, width: '160px' },
        { label: 'BusinessStockSearch.table.skuCode', prop: 'skuCode', isCheck: true, disabled: false, width: '160px' },
        {
          label: 'BusinessStockSearch.table.warehouseCode',
          prop: 'warehouseCode',
          isCheck: true,
          disabled: false,
          width: '160px',
        },
        {
          label: 'BusinessStockSearch.table.warehouseName',
          prop: 'warehouseName',
          isCheck: true,
          disabled: false,
          width: '160px',
        },
        // #ifndef OPEN-SOURCE
        { label: 'BusinessStockSearch.table.usableNum', prop: 'usableNum', isCheck: true, disabled: false, width: '150px' },
        // #endif
        { label: 'BusinessStockSearch.table.stockNum', prop: 'stockNum', isCheck: true, disabled: false, width: '150px' },
        // #ifndef OPEN-SOURCE
        { label: 'BusinessStockSearch.table.lockNum', prop: 'lockNum', isCheck: true, disabled: false, width: '130px' },
        // { label: 'BusinessStockSearch.table.wayNum', prop: 'wayNum', isCheck: true, disabled: false, width: '160px' },
        {
          label: 'BusinessStockSearch.table.preemptionNum',
          prop: 'preemptionNum',
          isCheck: true,
          disabled: false,
          width: '160px',
        },
        // { label: 'BusinessStockSearch.table.waitNum', prop: 'waitNum', isCheck: true, disabled: false, width: '200px' },
        // { label: 'BusinessStockSearch.table.reservedNum', prop: 'reservedNum', isCheck: true, disabled: false, width: '160px' },
        // #endif
        { label: 'BusinessStockSearch.table.typeCode', prop: 'typeCode', isCheck: true, disabled: false, width: '160px' },
        { label: 'BusinessStockSearch.table.categoryName', prop: 'categoryName', isCheck: true, disabled: false, width: '160px' },
        { label: 'BusinessStockSearch.table.brandName', prop: 'brandName', isCheck: true, disabled: false, width: '140px' },
        // { label: '操作', prop: 'bjTableAction', isCheck: true, disabled: true, width: 129},
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.$refs.BjPage.tableData = [{}];
  },
  methods: {
    handleConfirm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        alert('submit!');
      });
    },
    /** 创建库存 */
    onAdd() {
      // this.$refs.DataForm.show();
    },
    /** 下载模板 */
    onDown() {},
    // /** 更新 */
    // onUpdata() {},
    // /** 同步 */
    // onSync() {},
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
